/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlRiskHistoryEntry } from './ControlRiskHistoryEntry';
import {
    ControlRiskHistoryEntryFromJSON,
    ControlRiskHistoryEntryFromJSONTyped,
    ControlRiskHistoryEntryToJSON,
} from './ControlRiskHistoryEntry';

/**
 * 
 * @export
 * @interface ControlPaginatedRiskHistoryResponse
 */
export interface ControlPaginatedRiskHistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedRiskHistoryResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedRiskHistoryResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedRiskHistoryResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ControlRiskHistoryEntry>}
     * @memberof ControlPaginatedRiskHistoryResponse
     */
    results: Array<ControlRiskHistoryEntry>;
}

/**
 * Check if a given object implements the ControlPaginatedRiskHistoryResponse interface.
 */
export function instanceOfControlPaginatedRiskHistoryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedRiskHistoryResponseFromJSON(json: any): ControlPaginatedRiskHistoryResponse {
    return ControlPaginatedRiskHistoryResponseFromJSONTyped(json, false);
}

export function ControlPaginatedRiskHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedRiskHistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(ControlRiskHistoryEntryFromJSON)),
    };
}

export function ControlPaginatedRiskHistoryResponseToJSON(value?: ControlPaginatedRiskHistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlRiskHistoryEntryToJSON)),
    };
}

